module.exports = __webpack_public_path__ + "static/media/11-apr17sep17.6ab39409.pdf";